import { useEffect, useState } from 'react';
import type { IqSpecFields } from '@jfh/intake-shared';
import { api } from './api.js';

/** Re-ask the Worker after this long (it re-reads the API's spec as often). */
const MAX_AGE_MS = 60 * 1000;
let cached: { at: number; p: Promise<IqSpecFields | null> } | null = null;

function load(): Promise<IqSpecFields | null> {
  if (cached && Date.now() - cached.at < MAX_AGE_MS) return cached.p;
  const p = api
    .getIqFields()
    .then((r) => r.fields)
    .catch(() => {
      cached = null; // try again next time
      return null;
    });
  cached = { at: Date.now(), p };
  return p;
}

/**
 * The API's own iQ field list, read live from its spec (null until loaded, or
 * when it can't be read: callers then use the built-in list).
 */
export function useIqSpecFields(): IqSpecFields | null {
  const [fields, setFields] = useState<IqSpecFields | null>(null);
  useEffect(() => {
    let live = true;
    void load().then((f) => live && setFields(f));
    return () => {
      live = false;
    };
  }, []);
  return fields;
}
